export const initialise = () => {
    const banner = document.querySelector<HTMLElement>('.banner-hero')
    if (!banner) return
    
    const video = banner.querySelector<HTMLVideoElement>('video')
    if (!video) return
    
    const customHtml = banner.querySelector<HTMLElement>('.banner-customhtml')
    if (customHtml) {
        const backgroundImage = getComputedStyle(customHtml).backgroundImage
        const urlMatch = backgroundImage.match(/url\(['"]?([^'"]+)['"]?\)/)
        if (urlMatch) {
            video.setAttribute('poster', urlMatch[1])
        }
    }
}